
import { toggleHeightUnit, toggleWeightUnit } from "@/utils/family";
import { parseHeight, parseWeight } from "@/components/statistics/GrowthDataUtils";
import { cmToInches, gToLb } from "@/utils/family";

export function useUnitPreferences(
  babyProfile: any | null, 
  useMetricHeight: boolean, 
  useMetricWeight: boolean
) {
  // Parse original measurements
  const originalHeight = parseHeight(babyProfile?.originalHeight);
  const originalWeight = parseWeight(babyProfile?.originalWeight);
  
  const handleHeightUnitToggle = async () => {
    const newPreference = await toggleHeightUnit();
    return newPreference;
  };
  
  const handleWeightUnitToggle = async () => {
    const newPreference = await toggleWeightUnit();
    return newPreference;
  };
  
  // Format display values with correct unit conversion
  // The key issue was here - we need to recalculate these values when the unit preference changes
  const displayOriginalHeight = originalHeight ? (useMetricHeight ? originalHeight : cmToInches(originalHeight)) : null;
  const displayOriginalWeight = originalWeight ? (useMetricWeight ? originalWeight : gToLb(originalWeight)) : null;

  // For debugging
  console.log("[useUnitPreferences] Original height:", originalHeight, "cm");
  console.log("[useUnitPreferences] Original weight:", originalWeight, "g");
  console.log("[useUnitPreferences] Display height:", displayOriginalHeight, useMetricHeight ? "cm" : "inches");
  console.log("[useUnitPreferences] Display weight:", displayOriginalWeight, useMetricWeight ? "g" : "lb");
  console.log("[useUnitPreferences] Current unit preferences - Height:", useMetricHeight ? "metric" : "imperial", "Weight:", useMetricWeight ? "metric" : "imperial");

  return {
    displayOriginalHeight,
    displayOriginalWeight,
    handleHeightUnitToggle,
    handleWeightUnitToggle
  };
}
